<footer id="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-2">
              <div class="f-left">
                <a class="f-logo">
                  <img src="assets/img/marketing-page-logo.png" alt="">
                </a>
                <ul class="f-nav">
                  <li><a (click)="openTermsAndConditionsDialog()">Terms & Conditions</a></li>
                </ul>
              </div>
            </div>
            <div class="col-12 col-md-2">
              <div class="f-menu">
                <ul>
                  <li>Courses
                    <ul>
                      <li><a routerLink="/neet">NEET</a></li>
                      <li><a routerLink="/jee">JEE</a></li>
                    </ul>
                  </li>
                  <li><a routerLink="/about">About Us</a></li>
                </ul>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <div class="row">
                <div class="col-12 col-md-7">
                  <ul class="company-info m-company-info-hide">
                    <li class="assessment_pb-0">
                      <img src="assets/img/location-icon.svg" alt="">
                      <div class="info-txt">
                        <p>NCC Building, Durgamma Cheruvu Road, Vittal Rao Nagar, HITEC City, Hyderabad, Telangana 500081.</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-12 col-md-5">
                  <ul class="company-info m-company-info-hide">
                    <li>
                      <img src="assets/img/email-icon.svg" alt="">
                      <div class="info-txt">
                        <p class="email"><strong><a href="email:info@infinitylearn.com">info@infinitylearn.com</a></strong>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="share-icons">
                <a href="https://www.facebook.com/InfinityLearn.SriChaitanya/" (click)='socialMediaClicked("facebook")' target="_blank"><img
                        src="assets/img/facebook-icon.svg" alt=""></a>
                <a href="https://www.linkedin.com/company/78106236/admin/" (click)='socialMediaClicked("linkedin")' target="_blank"><img
                        src="assets/img/linkedin-icon.svg" alt=""></a>
                <a href="https://www.instagram.com/infinitylearnbysrichaitanya/" (click)='socialMediaClicked("instagram")' target="_blank"><img
                        src="assets/img/instagram-icon.svg" alt=""></a>
                <a href="https://www.youtube.com/channel/UC6DoFLtBiqMV9DZKAIGM0EA" (click)='socialMediaClicked("youtube")' target="_blank"><img
                        src="assets/img/youtube-icon.svg" alt=""></a>
                <a href="https://twitter.com/InfinityLearn_"(click)='socialMediaClicked("twitter")' target="_blank"><img
                        src="assets/img/twitter-icon.svg" alt=""></a>
              </div>
              <p class="copyright-txt">Copyright © 2021. All Rights Reserved 2021</p>
              <ul class="f-nav mobile-term">
                <li><a (click)="openTermsAndConditionsDialog()">Terms & Conditions</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>